/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisputeEvidenceItem
 */
export interface DisputeEvidenceItem {
    /**
     * 
     * @type {string}
     * @memberof DisputeEvidenceItem
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeEvidenceItem
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeEvidenceItem
     */
    description?: string;
}

/**
 * Check if a given object implements the DisputeEvidenceItem interface.
 */
export function instanceOfDisputeEvidenceItem(value: object): value is DisputeEvidenceItem {
    return true;
}

export function DisputeEvidenceItemFromJSON(json: any): DisputeEvidenceItem {
    return DisputeEvidenceItemFromJSONTyped(json, false);
}

export function DisputeEvidenceItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisputeEvidenceItem {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'url': json['url'] == null ? undefined : json['url'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function DisputeEvidenceItemToJSON(json: any): DisputeEvidenceItem {
    return DisputeEvidenceItemToJSONTyped(json, false);
}

export function DisputeEvidenceItemToJSONTyped(value?: DisputeEvidenceItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'url': value['url'],
        'description': value['description'],
    };
}

